// TODO: replace with webpack config { resolve: { alias: ... } }
/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
module.exports = {
  localAsset: (path) => require(`../../public/${path}`),
};
